import { render, staticRenderFns } from "./InfoLayout.vue?vue&type=template&id=ec2270ca&scoped=true"
import script from "./InfoLayout.vue?vue&type=script&lang=ts"
export * from "./InfoLayout.vue?vue&type=script&lang=ts"
import style0 from "./InfoLayout.vue?vue&type=style&index=0&id=ec2270ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2270ca",
  null
  
)

export default component.exports